import React from 'react';

import {
  StyledBoxUser,
  StyledIconClose,
  StyledList,
  StyledElement,
  StyledLink,
  StyledOuterLink,
  StyledDivScroll,
  StyledLogout,
  StyledIconLogout,
  StyledPerfil,
  // StyledElmentMenu,
  // StyledIconCollapase,
  StyledAvatarPerson
} from './UserMenuStyle';

/** HOC */
import withOutsideClick from '../Common/ClickOutside';

import { Close, Logout /* , Colapse */ } from '../../../../assets/images';
import { AVATAR_MEDIUM, getCropWithPath } from '../../../utils/crops';

const prod = window.API_URL === 'https://intranetapi.atresmedia.com/';

const UserMenu = ({
  show,
  isRoleAdminOrAccess,
  onCloseShowUser,
  menuUser,
  logout,
  goCMS,
  avatarPhoto,
  name,
  lastname,
  idEmployee,
  // idDepartment,
  upateAvatar,
  timeStamp
}) => (
  <StyledBoxUser show={show} menuUser={menuUser}>
    {/* <StyledIconCollapase svg={Colapse} onClick={onCloseShowUser} hover /> */}
    <StyledIconClose svg={Close} onClick={onCloseShowUser} hover />
    <StyledDivScroll>
      <StyledPerfil>
        <StyledAvatarPerson
          name={name}
          lastname={lastname}
          userId={String(idEmployee)}
          crop={getCropWithPath(String(idEmployee)) || AVATAR_MEDIUM}
          avatarPhoto={avatarPhoto}
          timeStamp={timeStamp}
        />
      </StyledPerfil>
      {/* <StyledList>
        <StyledElmentMenu>
          <StyledLink onClick={showApps}>Accesos directos</StyledLink>
        </StyledElmentMenu>
      </StyledList> */}
      <StyledList>
        <StyledElement id="menuElementMyProfile">
          <StyledOuterLink
            onClick={() => {
              onCloseShowUser();
              upateAvatar(idEmployee);
            }}
            href={
              prod
                ? 'https://fa-extj-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/faces/FuseWelcome'
                : 'https://fa-extj-test-saasfaprod1.fa.ocs.oraclecloud.com/fscmUI/faces/FuseWelcome'
            }
            target="_blank"
            id="menuLinkA3mia"
          >
            A3mia
          </StyledOuterLink>
        </StyledElement>
        <StyledElement id="menuElementMyEquip">
          <StyledLink
            onClick={onCloseShowUser}
            to={`/perfil/${idEmployee}/tickets`}
            id="menuLinkFoodTickets"
          >
            Vales de comida
          </StyledLink>
        </StyledElement>
        <StyledElement id="menuElementMyNotifications">
          <StyledOuterLink
            href="https://firmas.atresmedia.com/"
            target="_blank"
            id="menuLinkFirma"
          >
            Firma
          </StyledOuterLink>
        </StyledElement>
        {/* <StyledElement>
          <StyledLink onClick={onCloseShowUser} to="/agenda">
            Agenda
          </StyledLink>
        </StyledElement> */}
        {/* {typology === 'INTERNAL' && (
          <StyledElement id="menuElementAccessControl">
            <StyledLink
              to={`/perfil/${idEmployee}/control-acceso`}
              id="menuLinkAccessControl"
            >
              Control de acceso
            </StyledLink>
          </StyledElement>
        )} */}
        {/* {typology === 'INTERNAL' && (
          <StyledElement id="menuElementOffice">
            <StyledOuterLink
              href="https://www.office.com/?auth=2&home=1"
              target="_blank"
              id="menuLinkOffice"
            >
              Office
            </StyledOuterLink>
          </StyledElement>
        )} */}
        {/* <StyledElement id="menuElementWorkflow">
          <StyledOuterLink
            href="https://intranetapi.atresmedia.com/atresnet/oauth?redirect=home"
            target="_blank"
            id="menuLinkWorkflow"
          >
            Workflow
          </StyledOuterLink>
        </StyledElement> */}
        {isRoleAdminOrAccess && (
          <StyledElement onClick={goCMS} id="menuElementCMS">
            <StyledLink to="/" id="menuLinkCMS">
              Ir al CMS
            </StyledLink>
          </StyledElement>
        )}
      </StyledList>
    </StyledDivScroll>
    <StyledLogout onClick={logout}>
      <StyledIconLogout svg={Logout} />
      Salir
    </StyledLogout>
  </StyledBoxUser>
);
UserMenu.propTypes = {};

UserMenu.defaultProps = {
  open: false,
  menuUser: false
};

export default withOutsideClick(UserMenu);
